import 'css-chunksrc/client/pages/planzoneMembersPage/resource/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_i1ody_1",
  "input": "_input_i1ody_5",
  "openedInput": "_openedInput_i1ody_22",
  "iconOpen": "_iconOpen_i1ody_28",
  "iconClose": "_iconClose_i1ody_37",
  "listRoot": "_listRoot_i1ody_45",
  "list": "_list_i1ody_45",
  "role": "_role_i1ody_1",
  "textHidden": "_textHidden_i1ody_69",
  "selectedRole": "_selectedRole_i1ody_74",
  "selectedRoleIcon": "_selectedRoleIcon_i1ody_78",
  "selectedRoleTitle": "_selectedRoleTitle_i1ody_84",
  "roleDescription": "_roleDescription_i1ody_91",
  "readOnly": "_readOnly_i1ody_96",
  "compact": "_compact_i1ody_103"
};